import axiosInstance from "../axiosInterceptor";

export async function orderHistory(search, pageNo, perPage, studentPaymentStatus,categoryType) {
    const response = await axiosInstance.post(
        `student/orderHistory`,
        {
            search,
            pageNo,
            perPage,
            categoryType: "AssignmentHelp",
            studentPaymentStatus
        }
    );
    const data = response?.data;
    return data;
}


export async function orderHistoryForAssignmentHelp(search, pageNo, perPage, studentPaymentStatus) {
    const response = await axiosInstance.post(
        `student/orderHistory`,
        {
            search,
            pageNo,
            perPage,
              categoryType: "AssignmentHelp",
            studentPaymentStatus
        }
    );
    const data = response?.data;
    return data;
}

export async function orderHistoryForLiveSessionHelp(search, pageNo, perPage, studentPaymentStatus) {
    const response = await axiosInstance.post(
        `student/orderHistory`,
        {
            search,
            pageNo,
            perPage,
            studentPaymentStatus
        }
    );
    const data = response?.data;
    return data;
}

